import {useSelector} from "react-redux";
import {getAnimalParamsRequestID} from "../../selectors/animalParametersSelector";

/**
 * Niewidoczny komponent do testów E2E (Cypress).
 * Przechowuje ostatni RequestID z MQTT (FORCE_UPDATE ANIMAL_PARAMS),
 * dzięki czemu Cypress może sprawdzić czy parametry zwierząt są już przeliczone.
 */
export default function AnimalParamsRequestIndicator() {
    const requestID = useSelector(getAnimalParamsRequestID);
    return (
        <div
            id="animal-params-request-indicator"
            data-request-id={requestID ?? ""}
            style={{display: "none"}}
        />
    );
}
